if (!customElements.get('bbc-celebration-details')) {
customElements.define('bbc-celebration-details', class extends HTMLElement {
connectedCallback() {
this.variants = JSON.parse(this.querySelector('[data-cake-variants]').textContent);
this.sync = this.sync.bind(this);
this.submit = this.submit.bind(this);
this.addEventListener('change', this.sync);
document.addEventListener('submit', this.submit, true);
this.observer = new MutationObserver(this.sync);
this.observer.observe(this.closest('product-info') || this.parentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['value']});
this.sync();
}
disconnectedCallback() { this.observer?.disconnect(); document.removeEventListener('submit', this.submit, true); }
sync() {
const form = document.getElementById(this.dataset.form);
if (!form) return;
const variant = this.variants.find(v => String(v.id) === form.elements.namedItem('id')?.value);
const photo = Boolean(variant?.title.includes('Photo Cake'));
const fields = this.querySelector('[data-photo-fields]');
if (fields) {
fields.hidden = !photo;
fields.querySelectorAll('input,select').forEach(el => {el.disabled = !photo; el.required = photo;});
const file = fields.querySelector('input[type=file]');
const selected = file.files?.[0];
file.setCustomValidity(selected && (selected.size > 5 * 1024 * 1024 || !['image/png','image/jpeg','image/gif'].includes(selected.type)) ? 'Choose a PNG, JPG or GIF image no larger than 5 MB.' : '');
}
const message = this.querySelector('[name="properties[Cake message]"]');
if (message) message.setCustomValidity(/\p{Extended_Pictographic}/u.test(message.value) ? 'Please enter your cake message without emojis.' : '');
}
submit(event) {
if (event.target.id !== this.dataset.form) return;
this.sync();
const form = event.target;
if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
const file = form.elements.namedItem('properties[Cake photo]');
if (file && !file.disabled && file.files.length) {
event.preventDefault(); event.stopImmediatePropagation();
form.enctype = 'multipart/form-data';
HTMLFormElement.prototype.submit.call(form);
}
}
});
}